import { ILevelDomainData } from './level-domain-data';

export const levelProjectData = {
    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelProjectData = (typeof levelProjectData)[keyof typeof levelProjectData];

export interface ILevelProjectData extends ILevelDomainData {
    [levelProjectData.guid]: string;
    [levelProjectData.deleted]: boolean;
    [levelProjectData.inactive]: boolean;
}
